/*
    Copy-to-clipboard helper.

    Used by the API Access panel, which copies credential material — so nothing
    in here may log, store, or otherwise retain the value it is handed.

    navigator.clipboard requires a secure context (https, or localhost), which
    covers golfbert.com, dev.golfbert.com and `npm start`. The textarea fallback
    keeps http:// previews working.
*/
export const copyToClipboard = async (value) => {
  if (typeof value !== "string" || !value) {
    return false;
  }

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch (e) {
    // Permission denied or insecure context — fall through. Deliberately
    // no logging: `e` can carry the argument in some engines.
  }

  let el = null;
  try {
    el = document.createElement("textarea");
    el.value = value;
    el.setAttribute("readonly", "");
    el.style.position = "fixed";
    el.style.top = "-1000px";
    el.style.opacity = "0";
    document.body.appendChild(el);
    el.select();
    return document.execCommand("copy");
  } catch (e) {
    return false;
  } finally {
    // If execCommand throws, the textarea still holds the credential —
    // take it back out of the DOM either way.
    if (el && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};

export default copyToClipboard;
